var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIconContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#0467AB",
    strokeOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0009 10.0459C15.613 10.0459 12.0918 13.6986 12.0918 18.1595C12.0918 20.4241 13.091 22.4228 14.4786 24.2761C15.6387 25.8254 17.1235 27.3396 18.6162 28.8616L18.6162 28.8617L18.6163 28.8618C18.899 29.1501 19.182 29.4386 19.4631 29.7278C19.6043 29.873 19.7983 29.955 20.0009 29.955C20.2035 29.955 20.3974 29.873 20.5386 29.7278C20.8198 29.4386 21.1028 29.15 21.3855 28.8617C22.8782 27.3396 24.3631 25.8255 25.5231 24.2761C26.9108 22.4228 27.91 20.4241 27.91 18.1595C27.91 13.6986 24.3887 10.0459 20.0009 10.0459ZM13.5918 18.1595C13.5918 14.4869 16.481 11.5459 20.0009 11.5459C23.5208 11.5459 26.41 14.4869 26.41 18.1595C26.41 19.9617 25.6194 21.6449 24.3224 23.3771C23.2278 24.839 21.8269 26.2682 20.3329 27.7924L20.0009 28.1312L19.6688 27.7923C18.1749 26.2682 16.774 24.839 15.6794 23.3771C14.3824 21.6449 13.5918 19.9617 13.5918 18.1595ZM21.6827 18.1538C21.6827 19.0827 20.9297 19.8357 20.0009 19.8357C19.072 19.8357 18.3191 19.0827 18.3191 18.1538C18.3191 17.225 19.072 16.472 20.0009 16.472C20.9297 16.472 21.6827 17.225 21.6827 18.1538ZM23.1827 18.1538C23.1827 19.9111 21.7581 21.3357 20.0009 21.3357C18.2436 21.3357 16.8191 19.9111 16.8191 18.1538C16.8191 16.3966 18.2436 14.972 20.0009 14.972C21.7581 14.972 23.1827 16.3966 23.1827 18.1538Z",
    fill: "#0467AB",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconContact);
export default __webpack_public_path__ + "static/media/location_icon-contact.c598a591407feddb38ef2becb0257f45.svg";
export { ForwardRef as ReactComponent };